/**
 * COVID edition. Prioritizes STH over BOPIS for now.
 */
const METHOD_PRIORITY = [
  'shipToHome',
  'buyOnlinePickupInStore',
  'buyOnlineShipToStore',
  'deliverFromStore',
];

export default METHOD_PRIORITY;
